import { useState, useEffect } from 'react';
import { Sun, Moon } from 'lucide-react';
import { applyThemeDefaults } from '../charts/utils';

export default function ThemeToggle() {
  const [isDark, setIsDark] = useState(() => {
    if (typeof window === 'undefined') return true;
    const stored = localStorage.getItem('monarch-theme');
    if (stored) return stored === 'dark';
    return false; // Default to light mode
  });

  useEffect(() => {
    const root = document.documentElement;
    if (isDark) {
      root.classList.add('dark');
      root.classList.remove('light');
    } else {
      root.classList.remove('dark');
      root.classList.add('light');
    }
    localStorage.setItem('monarch-theme', isDark ? 'dark' : 'light');
    requestAnimationFrame(() => {
      applyThemeDefaults();
      window.dispatchEvent(new CustomEvent('theme-change'));
    });
  }, [isDark]);

  return (
    <button
      onClick={() => setIsDark(!isDark)}
      className="p-2 rounded-lg text-text-3 hover:text-text hover:bg-bg-2 transition-colors"
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Light mode' : 'Dark mode'}
    >
      {isDark ? <Sun className="w-[18px] h-[18px]" /> : <Moon className="w-[18px] h-[18px]" />}
    </button>
  );
}
